import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class BackOfANapkinTemplatesConfidenceMultiplierComponent extends Component {
  @service organisation;

  get confidence() {
    return this.args?.confidenceValue || null;
  }

  get value() {
    return isNaN(+this.args?.value) ? null : +this.args.value;
  }

  @action
  handleConfidenceChange(e) {
    this.args?.onConfidenceChange?.(e);
  }

  get confidenceOptions() {
    let options = [];
    if (this.args.type === 'Investment')
      options = this.organisation.investmentConfidenceOptions;
    if (this.args.type === 'Return')
      options = this.organisation.returnConfidenceOptions;
    return options;
  }

  get externalOptions() {
    if (
      Array.isArray(this.args.extraOptions) &&
      this.args.extraOptions.length > 0
    )
      return this.args.extraOptions;

    let options = [];
    const confidenceOptionsLabels = this.confidenceOptions.map((item) =>
      item.label.toLowerCase(),
    );

    //If the provided confidence label is not part of our list of confience options
    if (
      this?.args?.confidenceLabel &&
      !confidenceOptionsLabels.includes(
        this.args?.confidenceLabel?.toLowerCase(),
      )
    ) {
      options = [
        { label: this.args.confidenceLabel, value: this.args.confidenceValue },
      ];
    }
    return options;
  }

  get finalValue() {
    return this.value === null || this.confidence === null
      ? '-'
      : this.value * this.confidence;
  }

  get confidenceValueinEuros() {
    return this.value === null || this.confidence === null
      ? '-'
      : this.finalValue - this.value;
  }
}
